<form [formGroup]="form" novalidate action="#">
  <tidy-row>
    <tidy-search-input
      formControlName="search"
      [placeholder]="'Search group'"
      [icon]="'assets/svg/search-outline.svg'"
      class="header-search full-width" />
  </tidy-row>
</form>
<tidy-card>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <div class="vertical-align-center">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
        <button mat-icon-button disabled aria-label="Spacer"></button>
        <tidy-link item-right tappable (click)="goToAddSubteam(node)">{{node.name}}</tidy-link>
      </mat-tree-node>
      <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
        <button mat-icon-button matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <tidy-link item-right tappable (click)="goToTeamPage(node)">{{node.name}}</tidy-link>
        <tidy-image
          class="body-size"
          style="margin-left: 10px; filter: invert(42%) sepia(10%) saturate(7%) hue-rotate(315deg) brightness(93%) contrast(93%)"
          [src]="'assets/svg/home.svg'" />
        <tidy-text
          [helper]="node.addresses"
          style="margin-right:5px"
          [translate]="false" />
        <tidy-image
          class="body-size"
          style="filter: invert(42%) sepia(10%) saturate(7%) hue-rotate(315deg) brightness(93%) contrast(93%)"
          [src]="'assets/svg/person-circle.svg'" />
        <tidy-text
          [helper]="node.members"
          [translate]="false" />
      </mat-tree-node>
    </div>
  </mat-tree>
</tidy-card>
